import { motion, AnimatePresence } from "framer-motion";
const toTitleCase = (str = "") => {
  return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}
const CategoryList = ({
  isOpen,
  categories = [],
  selectedCategory,
  onSelect,
  onClose
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            className="fixed inset-0 bg-black/70 z-[9998]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          {/* Drawer */}
          <motion.div
            className="fixed left-0 top-0 h-[100vh] w-[320px] bg-white shadow-xl p-6 overflow-y-auto z-[9999]"
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >

            <div className="flex items-center justify-between mb-6">
              <h2 className="lg:text-[30px] md:text-[20px] text-[12px] font-outfit font-semibold ">
                Categories
              </h2>
              <img src="/images/cross.png" className="lg:w-8 lg:h-8 md:w-6 md:h-6 w-4 h-4 flex-shrink-0 cursor-pointer" onClick={() => onClose()} />
            </div>
            <ul className="space-y-4">
              {categories.map((category) => {
                const isActive = selectedCategory === category.category_id;

                return (
                  <li key={category.category_id}>
                    <button
                      onClick={() => {
                        onSelect(category.category_id);
                        onClose();
                      }}
                      className={`w-full text-left px-4 py-3 whitespace-nowrap rounded-xl lg:text-2xl md:text-xl sm:text-lg  font-outfit font-medium transition-all ${isActive
                        ? "bg-boonsOrange text-white"
                        : "bg-white text-[#181C2E] hover:bg-gray-200"
                        }`}
                    >
                      {toTitleCase(category.category_name)}
                    </button>
                  </li>
                );
              })}
            </ul>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CategoryList;
